/* eslint-disable quote-props */
// eslint-disable-next-line import/prefer-default-export
export const colors = {
  'primary': {
    '900': '#0B0928',
    '800': '#002644',
    '700': '#184060',
    '600': '#3A5778',
    '500': '#445AA7',
    '400': '#5676E4', // MAIN ACTION COLOR
    '300': '#7187D5',
    '200': '#B7C8E9',
    '100': '#E7EFFF',
  },
  'neutral': {
    '900': '#212529',
    '800': '#343A40',
    '700': '#495057',
    '600': '#6C757D',
    '500': '#ADB5BD',
    '400': '#CED4DA',
    '300': '#DEE2E6',
    '200': '#E9ECEF',
    '100': '#F8F9FA',
  },
  'secondary1': {
    '900': '#1B2914',
    '800': '#2A3D24',
    '700': '#395131',
    '600': '#597856',
    '500': '#6FB269',
    '400': '#7DD181', // MAIN COLOR
    '300': '#A0E69E',
    '200': '#B8F1BA',
    '100': '#DAF3DB',
  },
  'secondary2': {
    '900': '#332E1B',
    '800': '#433C20',
    '700': '#625C35',
    '600': '#8F8A54',
    '500': '#CECE6E',
    '400': '#E3E36A', // MAIN COLOR
    '300': '#F6EBB4',
    '200': '#F8F6CE',
    '100': '#FFFEE1',
  },
  'error': {
    main: '#FF5F58',
    dark: '#81504F',
  },
  'warning': {
    main: '#FFBE2F',
    dark: '#866536',
  },
  'success': {
    main: '#4CAF50',
    dark: '#4E6D4F',
  },
  'plus': {
    main: '#5676E4',
    dark: '#4C5ED4',
  },
};
